import { timeValidator } from "validators";
import * as yup from "yup";

const updateSettingValidator = yup
  .object({
    search_range: yup
      .object({
        latitude: yup
          .string()
          .required("Latitude is required")
          .test("is-digit", "Input should be number", (value) =>
            /\d+$/.test(value)
          ),
        longitude: yup
          .string()
          .required("Longitude is required")
          .test("is-digit", "Input should be number", (value) =>
            /\d+$/.test(value)
          ),
        radius: yup
          .string()
          .required("Radius is required")
          .test("is-digit", "Input should be number", (value) =>
            /\d+$/.test(value)
          ),
      })
      .required("Search range is required"),
    call_center: yup
      .string()
      .required("Call center is required")
      .test("is-phone", "Invalid phone format. e.g 8068", (value) =>
        /^[0-9]{4}$/.test(value)
      ),
    whatsapp_support_center: yup
      .string()
      .required("Whatsapp support center is required")
      .test("is-phone", "Invalid phone format. e.g +251912345678", (value) =>
        /^\+251(9|7)[0-9]{8}$/.test(value)
      ),
    telegram_support_center: yup
      .string()
      .required("Telegram support center is required"),
    email_support_center: yup
      .string()
      .required("Email support center is required")
      .email("Enter a valid email"),
    waiting_time: yup
      .string()
      .required("Waiting time is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    tax_percent: yup
      .string()
      .required("Tax percent is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    cut_percent: yup
      .string()
      .required("Cut percent is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    map_api_key: yup.string().required("Map api key is required"),
    app_store_url: yup
      .string()
      .required("App store url is required")
      .url("Invalid url"),
    playstore_url: yup
      .string()
      .required("Playstore url is required")
      .url("Invalid url"),
    welcome_mile: yup
      .string()
      .required("Welcome mile is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    trip_mile: yup
      .string()
      .required("Trip mile is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    driver_min_wallet: yup
      .string()
      .required("Driver min wallet is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    low_intense_color: yup
      .string()
      .required("Low intense color is required")
      .test("is-color", "Invalid hex color", (value) =>
        /^([A-Fa-f0-9]{8})$/.test(value)
      ),
    normal_intense_color: yup
      .string()
      .required("Normal intense color is required")
      .test("is-color", "Invalid hex color", (value) =>
        /^([A-Fa-f0-9]{8})$/.test(value)
      ),
    medium_intense_color: yup
      .string()
      .required("Medium intense color is required")
      .test("is-color", "Invalid hex color", (value) =>
        /^([A-Fa-f0-9]{8})$/.test(value)
      ),
    high_intense_color: yup
      .string()
      .required("High intense color is required")
      .test("is-color", "Invalid hex color", (value) =>
        /^([A-Fa-f0-9]{8})$/.test(value)
      ),
    special_hour: yup
      .array()
      .of(
        yup
          .object({
            name: yup.string().required("Name is required"),
            start_at: yup
              .string()
              .required("Start time is required")
              .test("is-time", "Invalid time format", timeValidator),
            end_at: yup
              .string()
              .required("End time is required")
              .test("is-time", "Invalid time format", timeValidator),
            percent: yup
              .string()
              .required("Percent is required")
              .test("is-digit", "Input should be number", (value) =>
                /\d+$/.test(value)
              ),
          })
          .required("Working time is required")
      )
      .required("Working time is required")
      .min(1, "At least one working time is required"),
    cancellation_percent: yup
      .string()
      .required("Cancellation Percent is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    cancellation_fee: yup
      .object({
        amount: yup
          .string()
          .required("Amount is required")
          .test("is-digit", "Input should be number", (value) =>
            /\d+$/.test(value)
          ),
        count: yup
          .string()
          .required("Count is required")
          .test("is-digit", "Input should be number", (value) =>
            /\d+$/.test(value)
          ),
      })
      .required("Cancellation Fee is required"),
    high_demand_percent: yup
      .string()
      .required("High demand percent is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    dispatch_config: yup
      .object({
        max_expansion_multiplier: yup
          .string()
          .required("Max expansion multiplier is required")
          .test("is-number", "Input should be a number", (value) =>
            /^\d+(\.\d+)?$/.test(value || "")
          )
          .test("min-value", "Multiplier must be at least 1.0", (value) => {
            const num = parseFloat(value || "0");
            return num >= 1.0;
          })
          .test("max-value", "Multiplier must be at most 10.0", (value) => {
            const num = parseFloat(value || "0");
            return num <= 10.0;
          }),
        timeout_minutes: yup
          .string()
          .required("Timeout minutes is required")
          .test("is-number", "Input should be a number", (value) =>
            /^\d+(\.\d+)?$/.test(value || "")
          )
          .test("min-value", "Timeout must be at least 1.0 minute", (value) => {
            const num = parseFloat(value || "0");
            return num >= 1.0;
          })
          .test("max-value", "Timeout must be at most 30.0 minutes", (value) => {
            const num = parseFloat(value || "0");
            return num <= 30.0;
          }),
        cycle_count: yup
          .string()
          .required("Cycle count is required")
          .test("is-integer", "Input should be a whole number", (value) =>
            /^\d+$/.test(value || "")
          )
          .test("min-value", "Cycle count must be at least 1", (value) => {
            const num = parseInt(value || "0", 10);
            return num >= 1;
          })
          .test("max-value", "Cycle count must be at most 100", (value) => {
            const num = parseInt(value || "0", 10);
            return num <= 100;
          }),
      })
      .required("Dispatch configuration is required"),
    decline_penalty_count: yup
      .string()
      .required("Decline penalty count is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    decline_penalty_amount: yup
      .string()
      .required("Decline penalty amount is required")
      .test("is-number", "Input should be number", (value) =>
        /^\d+(\.\d+)?$/.test(value || "")
      ),
    penalty_expiry_hours: yup
      .string()
      .required("Penalty expiry hours is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    lottery_rollout_days: yup
      .array()
      .of(yup.string().required())
      .required("Lottery rollout days are required"),
    lottery_winners_per_rollout: yup
      .string()
      .required("Lottery winners per rollout is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    lottery_enabled: yup.boolean().required("Lottery enabled status is required"),
    min_daily_trips: yup
      .string()
      .required("Min daily trips is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value || "")
      ),
    idle_penalty_amount: yup
      .string()
      .required("Idle penalty amount is required")
      .test("is-number", "Input should be number", (value) =>
        /^\d+(\.\d+)?$/.test(value || "")
      ),
    lottery_prize: yup
      .string()
      .required("Lottery prize is required"),
    lottery_split_enabled: yup.boolean().required("Lottery split status is required"),
    driver_max_debt: yup
      .string()
      .required("Driver max debt is required")
      .test("is-number", "Input should be number", (value) =>
        /^\d+(\.\d+)?$/.test(value || "")
      ),
    auto_ban_on_penalty_enabled: yup.boolean().required("Status is required"),
    max_penalty_strikes_for_ban: yup
      .string()
      .required("Max strikes is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value || "")
      ),
    auto_unban_duration_hours: yup
      .string()
      .required("Unban duration is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value || "")
      ),
  })

  .required();

export default updateSettingValidator;
